<template>
  <div>
    <a-descriptions bordered :size="'small'">
      <a-descriptions-item label="PayNum01">
        {{payrollInfo.pay_num01}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum02">
        {{payrollInfo.pay_num02}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum03">
        {{payrollInfo.pay_num03}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum04">
        {{payrollInfo.pay_num04}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum05">
        {{payrollInfo.pay_num05}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum06">
        {{payrollInfo.pay_num06}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum07">
        {{payrollInfo.pay_num07}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum08">
        {{payrollInfo.pay_num08}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum09">
        {{payrollInfo.pay_num09}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum10">
        {{payrollInfo.pay_num10}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum11">
        {{payrollInfo.pay_num11}}
      </a-descriptions-item>
      <a-descriptions-item label="PayDat01">
        {{payrollInfo.pay_dat01}}
      </a-descriptions-item>
      <a-descriptions-item label="PayDat02">
        {{payrollInfo.pay_dat02}}
      </a-descriptions-item>
      <a-descriptions-item label="PayDat03">
        {{payrollInfo.pay_dat03}}
      </a-descriptions-item>
      <a-descriptions-item label="PayCar01">
        {{payrollInfo.pay_car01}}
      </a-descriptions-item>
      <a-descriptions-item label="PayCar02">
        {{payrollInfo.pay_car02}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum17">
        {{payrollInfo.pay_num17}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum18">
        {{payrollInfo.pay_num18}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum19">
        {{payrollInfo.pay_num19}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum20">
        {{payrollInfo.pay_num20}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum21">
        {{payrollInfo.pay_num21}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum22">
        {{payrollInfo.pay_num22}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum23">
        {{payrollInfo.pay_num23}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum24">
        {{payrollInfo.pay_num24}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum25">
        {{payrollInfo.pay_num25}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum26">
        {{payrollInfo.pay_num26}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum27">
        {{payrollInfo.pay_num27}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum28">
        {{payrollInfo.pay_num28}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum29">
        {{payrollInfo.pay_num29}}
      </a-descriptions-item>
      <a-descriptions-item label="PayNum30">
        {{payrollInfo.pay_num30}}
      </a-descriptions-item>
    </a-descriptions>
    <br>
    <br>
    <br>
  </div>
</template>
<script>
  export default {
    props: ['payrollInfo'],
    data () {
      return {}
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Consultas/PayrollLabel.vue